import { Component, OnInit } from '@angular/core';

import { User } from '../../Models/index';

import { UserService, SeedDataService, ProfileDataService} from '../../Services/index';

import {TreeModule, TreeNode, InputTextModule} from 'primeng/primeng';

import { Observable }     from 'rxjs/Observable';

import { Profile } from '../../Models/profile.model';
// import { Wish } from '../../Models/wish';
@Component({
    //moduleId: "module.id",    
    templateUrl: './home.component.html'

})

export class HomeComponent implements OnInit {
    currentUser: User;
    users: User[] = [];
    errorMessage: string = '';
    isLoading: boolean = true;
    profiles: Profile[];
    imagePath: string;
    display: boolean = false;
    // wish: Wish = new PrimeWish();
    constructor(private userService: UserService, private profiledataservice: ProfileDataService, private seedDataService: SeedDataService) {
        this.profiledataservice.GetTodayBirthdays().subscribe((data: any) => {
            this.profiles = data;
        });
        this.profiledataservice.getImagePath().subscribe((_imagePath: string) =>
            this.imagePath = _imagePath
        );
    }

    ngOnInit() {

    }
    showDialogToAdd() {

    }
   

    showDialog() {
        this.display = true;
    }
    trackByFn(index: any, item: any) {
        return item.id;
    }
    deleteUser(id: number) {

        this.userService.delete(id).subscribe(() => { this.loadAllUsers() });
    }

    private loadAllUsers() {
        this.userService.getAll().subscribe(users => { this.users = users; });
    }



}
// class PrimeWish implements Wish {
//     constructor(
// 		public id?: any,
// 		public FromTeamMemberID?: any,
// 		public ToTeamMemberID?: any,
// 		public OccasionID?: any,
// 		public Wishes?: any,
// 		public IsReaded?: any
//     ) { }
// }


// WEBPACK FOOTER //
// ./src/app/Components/dashboard/home.component.ts